import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps as MuiCircularProgressProps,
  styled,
} from "@mui/material";

import { brandColors } from "../../utils/brand-colors";

const StyledCircularProgress = styled(MuiCircularProgress)(() => ({
  color: brandColors.mutinexYellow,
}));

interface CircularProgressProps extends MuiCircularProgressProps {}

export const CircularProgress: React.FC<CircularProgressProps> = ({ ...props }) => {
  return (
    <ProgressWrapper>
      <StyledCircularProgress {...props} />
    </ProgressWrapper>
  );
};

export default CircularProgress;

const ProgressWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
}));
